import React, { useState, useEffect } from "react";
import { get, camelCase } from "lodash";
import { Row, Col } from "react-bootstrap";
import { HomeWidgetCard, LoaderWrapper } from "../../components";
import { getHomePageDetails, getAllCounts } from "../../services";
import { useComponentDidUpdate, useRequest } from "../../abstracts";
import permissions from "../../mocks/menuPermissions.json";
import authService from "../../components/api-authorization/AuthorizeService";
import {
  faBuilding,
  faClipboardList,
  faUser,
} from "@fortawesome/pro-solid-svg-icons";

import RequestSummaryComponent from "./RequestSummaryComponent";
import CountCard from "./CountCard";
import TaskManagementNotificationComponent from "./TaskManagementNotificationComponent";
import EnrollmentAndEligibilityAnalyticsComponent from "./EnrollmentAndEligibilityAnalyticsComponent";
import SearchComponentHomePage from "./SearchComponentHomePage";

const NewHomeContainer = (props) => {
  const { history } = props;
  const [fetchCounts, setFetchCounts] = useState(true);
  const [roleName, setRoleName] = useState("VOU");
  const { response, loading } = useRequest({
    method: getHomePageDetails,
  });
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const { response: countsResponse, loading: isCountsLoading } = useRequest({
    method: getAllCounts,
    payload: response,
    stopTrigger: fetchCounts,
  });

  const onAddClick = (e, item) => {
    e.preventDefault();
    history.push(item.routeToAdd);
  };

  const onDidUpdate = () => {
    if (!loading) {
      setFetchCounts(false);
    }
  };

  useComponentDidUpdate(onDidUpdate, [loading]);
  return (
    <div style={{ marginLeft: "230px" }} className="w-100 new-home-container">
      <Row className="h-100">
        <Col md={8}>
          <Row style={{ width: "100%", marginBottom: "20px" }}>
            <SearchComponentHomePage />
          </Row>
          <Row style={{ justifyContent: "space-between", width: "100%" }}>
            <Col md={4} className="pl-0">
              <CountCard label="Company" icon={faBuilding} count="0" />
            </Col>
            <Col md={4}>
              <CountCard label="Plan" count="0" icon={faClipboardList} />
            </Col>
            <Col md={4} className="pr-0">
              <CountCard label="Employees" count="0" icon={faUser} />
            </Col>
          </Row>
          <Row style={{ marginTop: "20px", width: "100%" }}>
            <Col md={6} className="pl-0">
              <EnrollmentAndEligibilityAnalyticsComponent />
            </Col>
            <Col md={6} className="pr-0">
              <RequestSummaryComponent />
            </Col>
          </Row>
        </Col>
        <Col md={4} className="h-100">
          <TaskManagementNotificationComponent />
        </Col>
      </Row>
    </div>
  );
};

export default NewHomeContainer;
